<template>
  <div>
    <div class="d-flex mb-2">
      <text-field
        v-model="formData.first_name"
        name="First Name"
        label-class="flex-1 mr-3"
        :errorMessage="
          v$.formData.first_name
            ? firstErrorMessage(v$.formData.first_name)
            : ''
        "
      ></text-field>
      <text-field
        v-model="formData.last_name"
        name="Last Name"
        label-class="flex-1"
        :errorMessage="
          v$.formData.last_name ? firstErrorMessage(v$.formData.last_name) : ''
        "
      ></text-field>
    </div>
    <div class="mb-2">
      <div class="form-control-label"><b>Email</b></div>
      <email-field v-model="formData.email" primary hide-buttons></email-field>
      <div class="form-control-label"><b>Phone</b></div>
      <phone-field
        v-model="formData.phone"
        primary
        hide-buttons
        name="phone"
      ></phone-field>
    </div>
  </div>
</template>

<script>
import { getQueryVariables } from "@/lib/url.js";
import { firstErrorMessage } from "@/lib/vuelidate_helpers";

import TextField from "@/components/TextField.vue";
import EmailField from "@/Customer/EmailField.vue";
import PhoneField from "@/Customer/PhoneField.vue";
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";

export default {
  components: {
    TextField,
    EmailField,
    PhoneField
  },
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      formData: {
        first_name: "",
        last_name: "",
        email: { email_address: "", primary: true },
        phone: { phone_number: "", type: "", primary: true }
      }
    };
  },
  created() {
    const { first_name, last_name, phone } = getQueryVariables();
    if (first_name !== "Wireless") {
      this.formData.first_name = first_name;
    }
    if (last_name !== "Caller") {
      this.formData.last_name = last_name;
    }
    if (phone) {
      this.formData.phone.phone_number = phone.replace("+", " ");
    }
  },
  validations() {
    return {
      formData: {
        first_name: {
          required: helpers.withMessage("First name is required", required),
          $autoDirty: true
        },
        last_name: {
          required: helpers.withMessage("Last name is required", required),
          $autoDirty: true
        }
      }
    };
  },
  methods: {
    firstErrorMessage,
    async getFormData() {
      const isValid = await this.v$.$validate();
      if (isValid) {
        const { first_name, last_name, email, phone } = this.formData;
        return {
          first_name,
          last_name,
          emails: [email],
          phones: [phone]
        };
      }
    },
    async validate() {
      const isValid = await this.v$.$validate();
      return isValid;
    }
  }
};
</script>

<style lang="scss" scoped></style>
